import React from "react";
import PageLayout from "../../PageLayout";
import SecondPage from "./SecondPage";
import FourthPage from "./FourthPage";
import VideoCareer from "./VideoCareer";

const videos = [
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/7vuYu7FOfg4?si=M_ARoQ1htCh2hJ9r"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/i3Y-Y5Pvj-8?si=YwFBupGrZpfGwEU0"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/b7beWKRM8M8?si=aKXKaCpNloRPUvra"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/eNiR-4Mbj-I?si=GsMa5OyZO8KMpg7-"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/A55fmn4wAwg?si=Ox-BBFxuvLRLpU6q"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>
];

function DestinationPromotional() {
  return (
    <div>
      <PageLayout
        title="Let us give wings to your stories"
        description="We at IBEX FILMZ understand the evolving landscape of digital media and its impact on audiences worldwide. Leveraging cutting-edge technology and creative storytelling, we ensure that each video or film we produce not only meets but exceeds the expectations of our clients. Our team of experts specializes in bringing ideas to life, transforming visions into cinematic experiences that resonate with viewers, leaving a lasting impression. "
        videosrc="./video.mp4"
      />
      <SecondPage
        title="Destination Promotional Videos"
        para="Embark on a visual journey to captivating destinations with our Destination Promotional Videos playlist! 
Join us as we transport you to breathtaking locales, from sun-kissed beaches to bustling cityscapes, through our immersive and captivating videos. Whether you're dreaming of exotic getaways or seeking inspiration for your next adventure, our videos will ignite your wanderlust and showcase the beauty and allure of each destination.
 "
      />
      <VideoCareer videos={videos} />

      {/* <FourthPage /> */}
    </div>
  );
}

export default DestinationPromotional;
